export const themeData = [
    {
        name: 'Analyzing or Calculating',
        desc: 'A job function where you get to calculate or interpret the meaning of numbers or data.',
        videoID: "6894f0dabcf5dc9e172c9ebd"
    },
    {
        name: 'Artistic Creation',
        desc: 'A job function where you get to be creative from an artistic perspective.',
        videoID: "6894f0daaa43dddb5c51340d"
    },
    {
        name: 'Chronicling or Documenting',
        desc: 'A job function where you get to record and report facts, observations, or conclusions about people, events, places, or processes.',
        videoID: "6894f0daaa43dddb5c51340a"
    },
    {
        name: 'Coaching or Mentoring',
        desc: 'A job function where you get to work with individuals to improve their performance and move them closer to becoming the best they can be in a specific activity or area of their life.',
        videoID: "6894f0daaa43dddb5c51341b"
    },
    {
        name: 'Competition',
        desc: 'A job function where you get to pit your skills or knowledge against those of others in a quest to be the best, because you love to win.',
        videoID: "6894f0da8d992eda26b4f3ef"
    },
    {
        name: 'Designing',
        desc: 'A job function where you get to be a creator of things from the perspective of form, function, and beauty.',
        videoID: "6894f0dabcf5dc9e172c9ea1"
    },
    {
        name: 'Entertaining',
        desc: 'A job function where you get to perform and connect with an audience on an emotional level to make them feel happiness, sadness, love, fear, anxiety, excitement, or awe.',
        videoID: "6894f0d9aa43dddb5c5133c1"
    },
    {
        name: 'Evaluating or Judging',
        desc: 'A job function that involves a process of evaluating or judging to determine quality, worth, appropriateness, or best option.',
        videoID: "6894f0dabcf5dc9e172c9e9a"
    },
    {
        name: 'Exploring or Adventuring',
        desc: 'A job function where you get to be outdoors and go boldly where few have gone before.',
        videoID: "6894f0daaa43dddb5c51341e"
    },
    {
        name: 'Fabricating or Fixing',
        desc: 'A job function where you get to work with your hands and use tools to either build, install, assemble, repair, or restore things.',
        videoID: "6894f0d9aa43dddb5c5133b8"
    },
    {
        name: 'Healing or Caring',
        desc: 'A job function where you get to care for the well-being of people, plants, or animals.',
        videoID: "6894f0daaa43dddb5c5133d2"
    },
    {
        name: 'Helping or Serving',
        desc: 'A job function where you get to be helpful and supportive in attending to the needs of others.',
        videoID: "6894f0daaa43dddb5c5133d9"
    },
    {
        name: 'Improving or Perfecting',
        desc: 'A job function where your primary focus is on making improvements to products, services, systems, procedures, processes, results, or relationships.',
        videoID: "6894f0da8d992eda26b4f407"
    },
    {
        name: 'Investigating or Fact Finding',
        desc: 'A job function that involves the process of fact finding and deductive reasoning to plot strategy or solve mysteries and complex problems.',
        videoID: "6894f0da8d992eda26b4f411"
    },
    {
        name: 'Leading or Controlling',
        desc: 'A job function where you get to be in charge and in control of situations and their outcomes.',
        videoID: "6894f0dabcf5dc9e172c9e85"
    },
    {
        name: 'Organizing or Coordinating',
        desc: 'A job function where you get to organize and coordinate, itineraries, events, people, projects, or information.',
        videoID: "6894f0dabcf5dc9e172c9eaf"
    },
    {
        name: 'Persuading',
        desc: 'A job function where you get to influence people in terms of their beliefs, attitudes, motivations, or behaviors.',
        videoID: "6894f0daaa43dddb5c5133ed"
    },
    {
        name: 'Science',
        desc: 'A job function that requires an adherence to the scientific method while conducting experiments to validate a hypothesis.',
        videoID: "6894f0da8d992eda26b4f415"
    },
    {
        name: 'Socializing',
        desc: 'A job function where you get to work closely with others because you thrive on the camaraderie and sense of community that happens with social interaction.',
        videoID: "68951b6abcf5dc9e172eaf3b"
    },
    {
        name: 'Storytelling',
        desc: 'A job function where you create and communicate stories that connect on an emotional level to make audiences feel happiness, sadness, love, fear, anxiety, excitement, or awe.',
        videoID: "6894f0da8d992eda26b4f432"
    },
    {
        name: 'Teaching or Training',
        desc: 'A job function where you get to educate people with knowledge or how-to skills that were previously unknown to them.',
        videoID: "6894f0daaa43dddb5c51340f"
    }
]